/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class McpToolsResponse {
    getFixupPrototypeFunction() { return McpToolsResponse.fixupPrototype; }

    static newInstance(model: Partial<McpToolsResponse>): McpToolsResponse {
        let obj = Object.assign(new McpToolsResponse(), model);
        McpToolsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<McpToolsResponse>): McpToolsResponse {
        if (!model) return null;
        return McpToolsResponse.newInstance(<McpToolsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: McpToolsResponse) {
        if (!obj) return;

        models.McpToolsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: McpToolsResponse): boolean {
        Object.setPrototypeOf(obj, McpToolsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
    }

    /**
     * Total number of tools across all matching servers.
     */
    total_count: number;

    /**
     * Flat list of MCP tools available for the given tenant and business agent.
     */
    tools: Array<any>;

}
